import React from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./app/store";
import i18n from "./i18n";
import "./index.css";
import { ErrorBoundary } from "./screens/ErrorBoundary";

const rootElement: HTMLElement | null = document.getElementById("root");

if (rootElement != null) {
  window.addEventListener("load", () => {
    setTimeout(() => {
      window.scrollTo(0, 1);
    }, 0);
  });

  ReactDOM.createRoot(rootElement).render(
    <ErrorBoundary>
      <React.StrictMode>
        <Provider store={store}>
          <I18nextProvider i18n={i18n}>
            <App />
          </I18nextProvider>
        </Provider>
      </React.StrictMode>
    </ErrorBoundary>
  );
} else {
  document.body.innerHTML =
    '<div style="color: red; text-align: center; padding: 20px;">Erro: Não foi possível encontrar o elemento raiz para renderizar o aplicativo.</div>';
  console.error(
    "There is not a root element where the react spa can be appended."
  );
}
